import React, { useEffect, useState } from 'react';
import { TabOptions } from '../../../../../../../cronGeneratorState/cronGeneratorContext';
import { Checkbox, Radio } from 'antd';
import { CheckboxChangeEvent } from 'antd/lib/checkbox';
import Text from 'components/Text/Text';
import style from './SpecificSelectors.module.scss';

interface ISpecificSelectors {
	onSetResult: (value: string) => void;
}

interface ISpecificValuesItem {
	value: string;
	isChecked: boolean;
}

const SpecificSelectors: React.FC<ISpecificSelectors> = ({ onSetResult }) => {
	const [checkedSpecificValues, setCheckedSpecificValues] = useState<ISpecificValuesItem[]>([]);
	const specificValues = Array.from(Array(60), (_, i) => ('0' + i).slice(-2)).map((el) => ({
		value: el,
		isChecked: false,
	}));

	const result = checkedSpecificValues
		.map((el) => el.value.replace(/^0/, ''))
		.sort((a, b) => parseInt(a) - parseInt(b))
		.join(',');

	useEffect(() => {
		onSetResult(result);
	}, [result]);

	useEffect(() => {
		const defaultValue = { ...specificValues[0], isChecked: true };
		!checkedSpecificValues.length && setCheckedSpecificValues([defaultValue]);
	}, []);

	const handleCheck = (e: CheckboxChangeEvent) => {
		setCheckedSpecificValues((prevState) => {
			const isChecked = e.target.checked;
			const value = e.target.value;
			return isChecked ? [...prevState, { value, isChecked }] : prevState.filter((el) => el.value !== value);
		});
	};

	return (
		<div className={style.radioField}>
			<div className={style.labelContainer}>
				<Radio value={TabOptions.SPECIFIC_OPTION} id={TabOptions.SPECIFIC_OPTION + 'minutesTab'} />
				<label className={style.label} htmlFor={TabOptions.SPECIFIC_OPTION + 'minutesTab'}>
					<Text translationNameSpace="form" translationKey="specificMinuteLabel" asFragment={true} />
				</label>
			</div>
			<div className={style.selectors}>
				{specificValues.map((value) => {
					const checked = checkedSpecificValues.find((el) => el.value === value.value)?.isChecked;
					return (
						<Checkbox
							key={value.value}
							className={style.checkBoxElement}
							value={value.value}
							checked={checked}
							onChange={handleCheck}>
							{value.value}
						</Checkbox>
					);
				})}
			</div>
		</div>
	);
};

export default React.memo(SpecificSelectors);
